// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  signalingServerUrl: 'https://mojarhiv.net:8025/hubs',

  //signalingServerUrl: 'http://localhost:60404/hubs',
 // signalingServerUrl: 'https://testsignalinghubnai.mojarhiv.net/hubs',
  //signalingServerUrl: 'https://10.53.19.20:8883/hubs',


  iceServers: [{
   // urls: ["stun:fr-turn1.xirsys.com"]
    urls:['stun:stun.callwithus.com:3478', 'stun:stun1.l.google.com:19302', 'stun:stun.stunprotocol.org:3478']
  },

    {
      username: "soft",
      credential: "Fb7DJPrBPaejg69b",
      urls: ["turn:turn.mojarhiv.net:3478"]

    }

    /*{
      username: "jaka@soft.si",
      credential: "test1234",
      urls: ["turn:numb.viagenie.ca"]

    }*/
    /*{
    username: "JmYvhISloZC2AENlVfISpDvx_OKmU5gU2IgpP-yGoaATI0nPxT2CfNGKs2HL5Y3bAAAAAGHUlDRzb2Z0ZG9v",
    credential: "8bbf90c2-6d8d-11ec-8d77-0242ac120004",
    urls: [
      "turn:fr-turn1.xirsys.com:80?transport=udp",
      "turn:fr-turn1.xirsys.com:3478?transport=udp",
      "turn:fr-turn1.xirsys.com:80?transport=tcp",
      "turn:fr-turn1.xirsys.com:3478?transport=tcp",
      "turns:fr-turn1.xirsys.com:443?transport=tcp",
      "turns:fr-turn1.xirsys.com:5349?transport=tcp"
    ]
    }*/

  ]


  //iceServers: [
  //  { urls: ['stun:stun.callwithus.com:3478', 'stun:stun1.l.google.com:19302', 'stun:stun.gmx.net:3478', 'stun:stun.stunprotocol.org:3478'  ] },
   // { urls: 'stun:stun.callwithus.com:3478' },
   //   { urls: 'stun:stun1.l.google.com:19302' },
   //{ urls: 'stun:stun.gmx.net:3478' },
   // { urls: 'stun:stun.stunprotocol.org:3478' },
   //{ urls: 'stun:stun3.l.google.com:19302' }
  //]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
